"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _button = _interopRequireDefault(require("../../../../core/button"));
var _modal = _interopRequireDefault(require("../../../../core/modal"));
var _input = _interopRequireDefault(require("../../../../core/input"));
var _inputOnBlur = _interopRequireDefault(require("../../../../core/input-on-blur"));
var _email = _interopRequireDefault(require("../../../../../icons/email"));
var _sendEmailButton = _interopRequireDefault(require("../../../../core/send-email-button"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } // This pops up a modal to display the actual email address
// with a send button.
// The reason for just not doing a direct 'mailto:'' from the table row is that:
// 1) in the case of postal entries the email must be editable.
// 2) several users use web mail and have said that mailto doesn't work for them.
// Although web mail can I think sometimes be set up to respond to mailto:,
// this relies on our users doing so.  This provides a compromise of allowing users
// to click a button or just copy and paste.
var _ref = /*#__PURE__*/_react.default.createElement(_email.default, null);
class EmailActions extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      isActioningEmail: false
    });
    _defineProperty(this, "_onActionEmail", () => {
      this.setState({
        isActioningEmail: true
      });
    });
    _defineProperty(this, "_onFinish", () => {
      this.setState({
        isActioningEmail: false
      });
    });
  }
  render() {
    const entry = this.props.entry;
    const modalButtons = /*#__PURE__*/_react.default.createElement("div", null, !entry.contactEmail ? null : /*#__PURE__*/_react.default.createElement(_sendEmailButton.default, {
      type: "primary",
      to: entry.contactEmail,
      subject: entry.competition.competitionName,
      onClick: this._onFinish
    }, "Write & Send Email"), /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: this._onFinish
    }, "Done"));
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_button.default, {
      type: "default",
      onClick: this._onActionEmail,
      style: {
        paddingTop: '.3em'
      }
    }, _ref), !this.state.isActioningEmail ? null : /*#__PURE__*/_react.default.createElement(_modal.default, {
      buttons: modalButtons,
      onClose: this._onFinish,
      title: 'Contact for ' + entry.bibName + ' Bib ' + entry.startListBib
    }, entry.isOnlineEntry ? /*#__PURE__*/_react.default.createElement("p", null, entry.contactEmail) : /*#__PURE__*/_react.default.createElement(_inputOnBlur.default, {
      enabled: true,
      type: "email",
      name: "contactEmail",
      value: entry.contactEmail,
      maxLength: 100,
      onChange: this.props.onChangeContactEmail
    })));
  }

  // *******************************************************************************
  // PartialQuery definition
  // *******************************************************************************
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
_defineProperty(EmailActions, "partialQueries", {
  Entry: {
    id: true,
    startListBib: true,
    bibName: true,
    contactEmail: true,
    isOnlineEntry: true,
    competition: {
      competitionName: true
    }
  }
});
var _default = exports.default = EmailActions;